'use strict';

var DefaultRoleViewDirective = function DefaultRoleViewDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/default-role-view.html'),
    controller: 'DefaultRoleViewController',
    scope: {
      visible: '='
    },
    link: function link($scope) {
      $scope.$on('grid:beforeUpdateBoundData', $scope.newGridDataLoaded);
    }
  };
};
DefaultRoleViewDirective.$inject = [];
module.exports = DefaultRoleViewDirective;